<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="icons/chevron/right-light"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <polygon id="bg" points="0 0 16 0 16 16 0 16" />
      <g
        id="icons/chevron/down-light"
        transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "
      >
        <polygon id="bg" points="0 0 16 0 16 16 0 16" />
        <polygon
          id="Stroke-2"
          :fill="color"
          fill-rule="evenodd"
          points="14.7627063 3.76313355 15.8232937 4.82386645 8 12.6460875 0.176706277 4.82386645 1.23729372 3.76313355 8 10.5249125"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#1D1D1D'
    }
  }
};
</script>
